import { networkApi } from '../infrastructure/api/NetworkApiClient';
import { ApiError } from '../infrastructure/api/BaseApiClient';

// SMGW History types
export interface SmgwHistoryPoint {
  timestamp: string;
  minValue: number;
  maxValue: number;
  avgValue: number;
  measurementCount: number;
}

export interface SmgwHistorySeries {
  obisCode: string;
  unit: string | null;
  dataPoints: SmgwHistoryPoint[];
}

export interface SmgwHistoryResponse {
  serialNumber: string;
  tafLogicalName?: string | null;
  timeRange: string;
  series: SmgwHistorySeries[];
}

/**
 * Get historical SMGW measurements for charts
 * @param serialNumber The SMGW serial number
 * @param timeRange Time range: "24h", "7d", or "30d"
 * @param tafLogicalName Optional: Filter by specific TAF profile (individual meter)
 */
export async function getSmgwHistory(
  serialNumber: string,
  timeRange: '24h' | '7d' | '30d' | '90d' | '365d' = '24h',
  tafLogicalName?: string,
  anchorIso?: string
): Promise<SmgwHistoryResponse> {
  try {
    let url = `/measurements/history/${encodeURIComponent(serialNumber)}?timeRange=${timeRange}`;
    if (tafLogicalName) {
      url += `&tafLogicalName=${encodeURIComponent(tafLogicalName)}`;
    }
    if (anchorIso) {
      // Window ends at this historical instant (map time-rewind) instead of now
      url += `&anchor=${encodeURIComponent(anchorIso)}`;
    }
    return await networkApi.zoneGet<SmgwHistoryResponse>(url);
  } catch (error) {
    if (error instanceof ApiError) {
      throw new Error(`Failed to get SMGW history: ${error.message}`, { cause: error });
    }
    throw error;
  }
}

export const maasService = {
  getSmgwHistory
};

export default maasService;
